import React, { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import { Spinner } from '@/components/common/UI/Spinner'
import { useAuthStore } from '@/store'

const OAuthCallback: React.FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const handled = useRef(false)
  const { setTokens, refreshUser } = useAuthStore()

  useEffect(() => {
    if (handled.current) return
    handled.current = true

    const params = new URLSearchParams(window.location.hash.slice(1))
    const accessToken = params.get('access_token')
    const refreshToken = params.get('refresh_token')
    window.history.replaceState(null, '', window.location.pathname)

    if (searchParams.has('error') || !accessToken || !refreshToken) {
      toast.error('Не удалось войти через выбранный сервис. Попробуйте другой способ.')
      navigate('/login', { replace: true })
      return
    }

    setTokens(accessToken, refreshToken)
    void refreshUser().then(() => {
      if (useAuthStore.getState().user) {
        toast.success('Вход выполнен')
        navigate('/dashboard', { replace: true })
      } else {
        useAuthStore.getState().logout()
        toast.error('Не удалось загрузить профиль аккаунта')
        navigate('/login', { replace: true })
      }
    })
  }, [navigate, refreshUser, searchParams, setTokens])

  return <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-secondary-600"><Spinner size="lg" /><p>Выполняется вход…</p></div>
}

export default OAuthCallback
